import { styled } from '@mui/material/styles';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Stack from '@mui/material/Stack';
import React from 'react';

var StyledBreadcrumbs = styled(Breadcrumbs)({
    '.MuiBreadcrumbs-li': {
        paddingBottom: 0,
        display: 'flex',
        maxWidth: '100%',
        minWidth: 0, // DON'T REMOVE THIS LINE, it's necessary for text-overflow to work properly. See https://stackoverflow.com/questions/67682635/text-overflow-in-css-flexbox-can-be-solved-by-simply-add-width0-but-why
    },
    '.MuiBreadcrumbs-separator': {
        paddingBottom: 0,
        display: 'flex',
    },
    '.MuiBreadcrumbs-ol': {
        flexWrap: 'nowrap',
    },
});
var Breadcrumb = styled('span')(function (_a) {
    var theme = _a.theme;
    return ({
        textDecoration: 'none',
        fontWeight: 600,
        fontSize: '14px',
        color: theme.palette.primary.main,
        display: 'inline-block',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        width: '100%',
    });
});
var Separator = styled('span')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'inline-block',
        width: '0.1em',
        height: '1em',
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1em',
        transform: 'skew(-12deg)',
    });
});
var getRenderedBreadcrumb = function (items, LinkComponent, fontSize, maxWidth) {
    var res = items.map(function (item) {
        if (item.to) {
            return (React.createElement(LinkComponent, { key: item.label, color: "inherit", to: item.to, style: { textDecoration: 'none', display: 'flex', width: '100%' } },
                React.createElement(Breadcrumb, { key: item.label, role: "button", sx: { fontSize: fontSize, maxWidth: maxWidth } }, item.label)));
        }
        if (item.onClick) {
            return (React.createElement(Breadcrumb, { key: item.label, role: "button", sx: { fontSize: fontSize, maxWidth: maxWidth } }, item.label));
        }
        return (React.createElement(Breadcrumb, { key: item.label, role: "button", sx: { fontSize: fontSize, maxWidth: maxWidth } }, item.label));
    });
    return res;
};
var BrandclubBreadcrumbs = function (_a) {
    var _b = _a.fontSize, fontSize = _b === void 0 ? 14 : _b, maxWidth = _a.maxWidth, items = _a.items, LinkComponent = _a.LinkComponent;
    var breadcrumbs = getRenderedBreadcrumb(items, LinkComponent, fontSize, maxWidth);
    return (React.createElement(Stack, { spacing: 2 },
        React.createElement(StyledBreadcrumbs, { separator: React.createElement(Separator, { sx: { fontSize: fontSize } }), "aria-label": "breadcrumb" }, breadcrumbs)));
};

export { BrandclubBreadcrumbs };
//# sourceMappingURL=BrandclubBreadcrumbs.js.map
